export const formatBrand = (brand: string) => {
  return brand
    .replace('.', '')
    .replace('-', '')
    .replace(/\s+/g, '')
    .replace("'", '')
    .toUpperCase();
};

// When adding any brands please follow the logic above in 'formatBrand',
// ensuring we do a 'fuzzy' search.
const exclusiveBrands = [
  // Women's Line
  '41HAWTHORN',
  'AWHILE',
  'GOLDRAY',
  'MAGNOLIAGRACE',
  'MARKET&SPRUCE',
  'MARKET&SPRUCEACTIVE',
  'MARKET&SPRUCELOUNGE',
  'MIXBY41HAWTHORN',
  'MOHNTONMADE',
  'WEWANDER',

  // Men's Line
  '01ALGO',
  'AFRAME',
  'ALESBURY',
  'ARTEFACT',
  'BIXBYNOMAD',
  'EVENTIDE',
  'FAIRLANE',
  'FAIRLANE&SONS',
  'HAWKERRYE',
  'R+R',
  'REDALEBYALESBURY',
  'RYEBYHAWKERRYE',
];

const excludedBusinessLines: (string | undefined)[] = ['KIDS'];
const excludedDepartments: (string | undefined)[] = [
  // Values are from the selected SKU's department
  'Jewelry',
  'Footwear',

  // Values are from Shop Product product type klass
  'Jewellery',
  'Clothing Accessories',
  'General Purpose Footwear',
];
const excludedItemTypes: (string | undefined)[] = [
  // Value is from selected SKU's item type
  'Accessories',

  // Values are from Shop Product product type family
  'Personal Accessories',
  'Footwear',
];

export const isExclusiveBrand = (brand: string) => {
  if (!brand) {
    return false;
  }

  return exclusiveBrands.includes(formatBrand(brand));
};

export const sizeGuideSupported = (
  brand: string,
  businessLine: string,
  department?: string,
  itemType?: string,
) => {
  return (
    isExclusiveBrand(brand) &&
    !excludedBusinessLines.includes(businessLine.toUpperCase()) &&
    // Should return true if itemType or department is null/undefined.
    !excludedDepartments.includes(department) &&
    !excludedItemTypes.includes(itemType)
  );
};
